import { useMemo, useState } from "react";
import { FILTERS } from "../data/products";
import { useProducts } from "../context/ProductsContext";
import { ProductCard } from "./ProductCard";

export const MenuSection = () => {
  const [active, setActive] = useState([]);
  // Live catalog from the Worker/D1 (falls back to the built-in menu).
  const { products: PRODUCTS, source } = useProducts();

  const toggle = (key) =>
    setActive((cur) => (cur.includes(key) ? cur.filter((k) => k !== key) : [...cur, key]));

  const filtered = useMemo(() => {
    if (active.length === 0) return PRODUCTS;
    return PRODUCTS.filter((p) => active.every((k) => (p.tags || []).includes(k)));
  }, [active, PRODUCTS]);

  return (
    <section id="menu" className="py-20 lg:py-28 bg-creamSoft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-olive">Today's Menu</span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-ink tracking-tight">
            Baked fresh, sweetened naturally
          </h2>
          <p className="mt-4 text-[#524B46] leading-relaxed">
            Every item is 100% free of added sugar. Filter by your dietary preference to find your perfect treat.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-3" data-testid="menu-filters">
          <button
            data-testid="filter-all"
            onClick={() => setActive([])}
            className={`px-5 py-2.5 rounded-full text-sm font-medium border transition-all ${
              active.length === 0
                ? "bg-olive text-cream border-olive"
                : "bg-white text-ink border-[#E8E2D9] hover:border-[#D2C7B8]"
            }`}
          >
            All Treats
          </button>
          {FILTERS.map((f) => {
            const on = active.includes(f.key);
            return (
              <button
                key={f.key}
                data-testid={`filter-${f.key}`}
                onClick={() => toggle(f.key)}
                className={`px-5 py-2.5 rounded-full text-sm font-medium border transition-all ${
                  on
                    ? "bg-terracotta text-white border-terracotta"
                    : "bg-white text-ink border-[#E8E2D9] hover:border-[#D2C7B8]"
                }`}
              >
                {f.label}
              </button>
            );
          })}
        </div>

        <p className="mt-6 text-sm text-[#787069]" data-testid="menu-count">
          Showing {filtered.length} of {PRODUCTS.length} treats
        </p>

        {source === "loading" ? (
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-testid="menu-loading">
            {[0, 1, 2].map((i) => (
              <div key={i} className="bg-white rounded-3xl border border-[#EFE9E0] overflow-hidden animate-pulse">
                <div className="aspect-[4/3] bg-[#F5F0EA]" />
                <div className="p-6 space-y-3">
                  <div className="h-5 w-2/3 rounded bg-[#F5F0EA]" />
                  <div className="h-4 w-full rounded bg-[#F5F0EA]" />
                  <div className="h-4 w-1/2 rounded bg-[#F5F0EA]" />
                </div>
              </div>
            ))}
          </div>
        ) : filtered.length === 0 ? (
          <div className="mt-8 text-center py-16 bg-white rounded-3xl border border-[#EFE9E0]">
            <p className="text-[#524B46]">No treats match all selected filters. Try removing one.</p>
          </div>
        ) : (
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {filtered.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
